export default __webpack_public_path__ + "static/Seasoned-Tech-Leaders-585f3a0b303734ec84c219cfad43f8ef.webp";